export default __webpack_public_path__ + "media/images/ui-icons_ef8c08_256x240-c9f7df56a383e08bce1ba1612105c18d.png";